import ModusServiceModel from "../ModusServiceModel";

export default class LaboratoryTestPackageModel extends ModusServiceModel {
  modelName() {
    return 'laboratory-test-packages';
  }
  icon() {
    return null;
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      identifier: null,
      name: null,
      description: null,
      billing_code: null,
      price: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      identifier: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      billing_code: (val) => (this.nullStringMutator(val)),
      price: (val) => (this.nullStringMutator(val)),
      position: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
}
